import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import styles from './VcStatusPopup.module.css';
import { makeStyles } from '@material-ui/core/styles';
import { Popover } from '@material-ui/core';

const VcStatusPopup = ({ asn }) => {
  const fields = [
    {
      name: 'VC',
      field: 'vc',
    },
    { name: 'Descr', field: 'vcDescription' },
    { name: 'Reason', field: 'lineOutReason' },
    { name: 'Agency', field: 'lineOutAgency' },
    { name: 'Comment', field: 'lineOutComment' },
  ];

  const [isTextOverflowPopupOpen, setIsTextOverflowPopupOpen] = useState(false);
  const [popoverVal, setPopoverVal] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleTextOverFlowPopOverOpen = (event, value) => {
    if (event.currentTarget.scrollWidth > event.currentTarget.clientWidth) {
      setPopoverVal(value);
      setIsTextOverflowPopupOpen(true);
      setAnchorEl(event.currentTarget);
    }
  };

  const handleTextOverFlowPopOverClose = () => {
    setIsTextOverflowPopupOpen(false);
    setAnchorEl(null);
  };
  const closePopup = () => setIsTextOverflowPopupOpen(false);
  const useTextOverflowPopoverStyles = makeStyles(theme => ({
    popover: {
      pointerEvents: 'none',
    },
    paper: {
      padding: theme.spacing(1),
      color: 'white',
      backgroundColor: 'grey',
      fontSize: '12px', //TODO: keep same as popover
    },
  }));

  const overflowPopoverClasses = useTextOverflowPopoverStyles();
  return (
    <div className={styles.AggregateBox}>
      <div className={styles.inner}>
        <div className={styles.vcNumberDisplay}>
          <div style={{ width: '40%', float: 'left' }}>VC</div>
          <div style={{ width: '60%', float: 'left', textAlign: 'right' }}>
            {asn['vc']}
          </div>
        </div>
        <div>
          <span className={styles.title}>
            <strong>LineOut</strong>
          </span>
        </div>

        {fields.map(({ name, field }) => (
          <div className={clsx(styles.row)}>
            <span> {name}</span>
            <strong
              onMouseEnter={e => handleTextOverFlowPopOverOpen(e, asn[field])}
              onMouseLeave={handleTextOverFlowPopOverClose}
            >
              {asn[field]}
            </strong>
          </div>
        ))}
      </div>

      <Popover
        open={isTextOverflowPopupOpen}
        anchorEl={anchorEl}
        onClose={closePopup}
        className={overflowPopoverClasses.popover}
        classes={{
          paper: overflowPopoverClasses.paper,
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {popoverVal}
      </Popover>
    </div>
  );
};

VcStatusPopup.propTypes = {
  asn: PropTypes.shape({
    description: PropTypes.string.isRequired,
    vc: PropTypes.string.isRequired,
    lineOutReason: PropTypes.string.isRequired,
    lineOutAgency: PropTypes.string.isRequired,
    lineOutComment: PropTypes.string,
  }),
};

export default VcStatusPopup;
